"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsBoolean, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
export function useHasMerchandisingQueryParam() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsBoolean.withDefault(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [hasMerchandising, setHasMerchandising] = useQueryState(QUERY_PARAM_KEYS.hasMerchandising, t0);
  let t1;
  if ($[1] !== setHasMerchandising) {
    t1 = async function toggleHasMerchandising() {
      await setHasMerchandising(_temp);
    };
    $[1] = setHasMerchandising;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleHasMerchandising = t1;
  let t2;
  if ($[3] !== hasMerchandising || $[4] !== toggleHasMerchandising) {
    t2 = {
      hasMerchandising,
      toggleHasMerchandising
    };
    $[3] = hasMerchandising;
    $[4] = toggleHasMerchandising;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(prev) {
  return prev ? null : true;
}